import React from 'react'
import { LayoutBand, Grid, colors, Card, Bleed, useContainerWidth } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import { baseUrl } from '@fs/zion-config'
import { i18n } from '@fs/zion-locale'
import { useTranslation } from 'react-i18next'
import PlaceReportsHeader from './components/PlaceReportsHeader/PlaceReportsHeader'
import PlaceReportsLeftNavPanel from './components/PlaceReportsLeftNavPanel/PlaceReportsLeftNavPanel'
import PlaceReportsContentPanel from './components/PlaceReportsContentsPanel/PlaceReportsContentPanel'
import PlaceReportsProvider, { usePlaceReportsData } from './PlaceReportsProvider'
import AuthoritiesAppPageHead from '../../AuthoritiesAppPageHead'

function PlaceReports() {
  const atWidth = useContainerWidth()
  const leftNavPanelColumns = atWidth({ default: 12, xl: 4 })
  const rightContentColumns = atWidth({ default: 12, xl: 8 })

  return (
    <div style={{ height: '100%' }}>
      <Grid gutters="xxs">
        <Card columns={12} margins="dense">
          <Bleed top>
            <PlaceReportsHeader />
          </Bleed>
        </Card>
        <Card columns={leftNavPanelColumns} margins="dense">
          <Bleed top>
            <PlaceReportsLeftNavPanel />
          </Bleed>
        </Card>
        <Card columns={rightContentColumns} margins="dense">
          <Bleed top>
            <PlaceReportsContentPanel />
          </Bleed>
        </Card>
      </Grid>
    </div>
  )
}

export default function PlaceReportsPage() {
  usePageView({ page_detail: 'PlaceReports' })

  const placeReportsData = usePlaceReportsData()
  const [t] = useTranslation()

  return (
    <PlaceReportsProvider placeManagerState={placeReportsData}>
      <AuthoritiesAppPageHead
        title={t('place-reports.page.title', 'Place Reports')}
        description={t(
          'place-reports-page.page.description',
          'Reports and guidelines for FamilySearch place regions, countries, and divisions.'
        )}
        canonicalUrl={`${baseUrl}/${i18n.language}/standards/manager/`}
      />
      <LayoutBand
        maxWidth="xxl"
        marginY="nano"
        marginX="nano"
        style={{ height: 'calc(100vh - 70px)', background: colors.gray02 }}
      >
        <PlaceReports />
      </LayoutBand>
    </PlaceReportsProvider>
  )
}
